import { em, rem } from '@mantine/core';

// Conversion tools for objects

type unitObject = {
  [x: string]: number | string;
};

const convertObjectOfUnits = {
  toRem: (object: unitObject) => {
    const newObject = {} as { [x: string]: string };
    return Object.keys(object).reduce((obj, key) => {
      obj[key] = rem(object[key]);
      return obj;
    }, newObject);
  },
  toEm: (object: unitObject) => {
    const newObject = {} as { [x: string]: string };
    return Object.keys(object).reduce((obj, key) => {
      obj[key] = em(object[key]);
      return obj;
    }, newObject);
  },
};

export { convertObjectOfUnits };
